import { render, staticRenderFns } from "./UsdcTransactionListItem.vue?vue&type=template&id=0098254d&scoped=true&"
import script from "./UsdcTransactionListItem.vue?vue&type=script&lang=ts&"
export * from "./UsdcTransactionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./UsdcTransactionListItem.vue?vue&type=style&index=0&id=0098254d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098254d",
  null
  
)

export default component.exports